function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Will not exist in Node.js envs, use with care
/* global window */
import mergeWith from 'lodash/mergeWith';
import merge from 'lodash/merge';
import debounce from 'debounce';
import isString from 'lodash/isString';
import { v4 } from 'uuid';
import { events, provider, utils as eventBuilderUtils } from '@scm-italy/pulse-event-builders';
import { syncWithCis } from '@scm-italy/pulse-cis-sync';
import EventQueue from '@scm-italy/event-queue-js';
import send from './network';
import DEFAULT_CONFIG from './config';
var EXPERIMENTATION_GLOBAL_NAME = 'AdevintaExperimentation';
var providerSdrn = provider.sdrn;
var evaluateAndFlatten = eventBuilderUtils.evaluateAndFlatten;
function getEventTrackingMethod(name) {
  return events[name] || events.trackerEvent;
}

/**
 * SDKConfigInput
 *
 * Override default settings of the SDK
 *
 * See `src/config-browser.js` and `src/config.js` for the default values for
 * browser and no browser environments.
 *
 * **Note**
 * - that the `username` and `password` are *for Node.js environments only*.
 * - that `globalVarNames` and `useExperimentation` are *for browser environments only*.
 */

/**
 * Internal state of the tracker.
 *
 * **Note**
 * - that the `username` and `password` are *for Node.js environments only*.
 * - that `globalVarNames` and `useExperimentation` are *for browser environments only*.
 */

/**
 * Input for event builders. Different events will read and process different
 * fields. See
 * [@scm-italy/pulse-event-builders](https://github.mpi-internal.com/spt-dataanalytics/pulse-event-builders)
 * for details.
 *
 * You can in general pass any data to any part of the event, only the processed
 * fields are documented.
 */

/**
 * Optional option used in `track` and `trackPageView`
 *
 * If `resolveOnQueued` is set to true then the promise returned by `track`/`trackPageView` will
 * resolved when the event is evaluated and added to to the internal queue. If it is falsy (default
 * value us `undefined`) the promise will resolve when the event have been transmitted over the
 * network.
 */

var GIT_COMMIT = "1be61469dce0167da2c4f3c35d86f5035a802fa8" || 'unknown';
var Tracker = /*#__PURE__*/function () {
  /**
   * @param {string} providerId (*required*). Id of the site or app. Should be
   * registered in [huginn](https://bifrost.schibsted.io/huginn)
   */
  function Tracker(providerId, config, builders) {
    var _this = this;
    _classCallCheck(this, Tracker);
    var SDK_VERSION = "5.2.1" || 'unknown';
    if (!providerId || !isString(providerId)) {
      throw new Error('Required parameter `providerId` missing');
    }
    this.state = merge({}, DEFAULT_CONFIG, {
      pageViewId: v4(),
      providerId: providerId
    }, config);
    this.queue = new EventQueue();

    // Move to default config?
    this.builders = merge({}, builders, {
      provider: {
        id: providerId
      },
      tracker: {
        version: "".concat(SDK_VERSION, "-").concat(GIT_COMMIT.slice(0, 5))
      }
    });

    // This is technically/strictly speaking not necessary to do before the
    // first event which requires an environmentId is sent. This will in most
    // cases be all events on client-instances and doing this immediately will
    // unblock the first event faster.

    // The reason for the timeout is to cover the case of
    // const tracker = new Tracker();
    // tracker.login('user@example.org');
    if (this.state.environment === 'browser') {
      setTimeout(function () {
        _this.cisSync();
      }, 10);
      if (window && window.navigator && window.navigator.sendBeacon) {
        window.addEventListener('pagehide', function () {
          _this.state.useBeacon = true;
          _this._sendImmediately();
        });
      }
      // Update global variable names to include experimentation
      if (window && this.state.useExperimentation) {
        this.state.globalVarNames.push(EXPERIMENTATION_GLOBAL_NAME);
      }
    }
  }
  return _createClass(Tracker, [{
    key: "cisSync",
    value: function cisSync() {
      var _this$builders$actor = this.builders.actor,
        actor = _this$builders$actor === void 0 ? {} : _this$builders$actor;
      var id = actor.id;
      var _this$state = this.state,
        nativeJwe = _this$state.nativeJwe,
        cisBaseUrl = _this$state.cisBaseUrl;
      return syncWithCis(id, nativeJwe, cisBaseUrl);
    }

    /**
     * Add event to the tracker event queue
     *
     * The input data is a can be objects, arrays, primitives or promises. The
     * order of calls to the method is not guaranteed to be sent in the same
     * sequence.
     *
     * ```
     * tracker.track('trackerEvent', {
     * actor: new Promise(resolve => setTimeout(() => resolve('person@example.org'), 2000))
     * });
     * tracker.track('trackerEvent', { type: 'Engagement '});
     *
     * ```
     *
     * The second call to `track` will be added to the event queue before the
     * first since all input to events are resolved before being added to the
     * internal queue. Setting the future value in the SDK state will block all
     * events and events will be added to the queue in order.
     *
     * ```
     * tracker.update({
     * actor: new Promise(resolve =>
     * setTimeout(() => resolve('person@example.org'), 2000)) })
     * tracker.track('trackerEvent', { type: 'View' });
     * tracker.track('trackerEvent', { type: 'Engagement' });
     * ```
     *
     * Both of these events will be blocked for two seconds and executed in order.
     *
     * @param {string} eventType. See [scm-italy/pulse-event-builders]() for
     * available event types
     * @param {object} data. input data to the given event. The given data and the
     * persisted data in the tracker will be merged before passing it to the event
     * function.
     *
     */
  }, {
    key: "track",
    value: function track(eventType, data, options) {
      var _this2 = this;
      var _track = function _track() {
        return _this2.evaluateEvent(eventType, data).then(function (event) {
          var promise = _this2._push(event, options);
          _this2.send();
          return promise;
        });
      };
      return this.cisSync().then(_track, _track);
    }

    /**
     * Evaluate all input given to the sdk/this method and pass it through the
     * appropriate event formatter.
     *
     */
  }, {
    key: "evaluateEvent",
    value: function evaluateEvent(eventType, data) {
      var _this3 = this;
      var eventBuilder = getEventTrackingMethod(eventType);
      // eslint-disable-next-line max-len
      return this.evaluateEventInputs(eventType, data).then(function (input) {
        return evaluateAndFlatten(eventBuilder(input, _this3.state));
      });
    }
  }, {
    key: "evaluateEventInputs",
    value: function evaluateEventInputs(eventType, data) {
      var eventDefaults = getEventTrackingMethod(eventType).defaults;
      this.update(this._getDataFromGlobalVars());
      return Promise.all([evaluateAndFlatten(this.builders), evaluateAndFlatten(data)]).then(function (builders) {
        var eventInput = builders.reduce(function (accl, p) {
          return merge(accl, p);
        }, {});
        return merge({}, eventDefaults(), eventInput);
      });
    }

    /**
     * Return a new Tracker with the current state
     */
    // eslint-disable-next-line no-use-before-define
  }, {
    key: "clone",
    value: function clone() {
      return new Tracker(this.state.providerId, _objectSpread({}, this.state), _objectSpread({}, this.builders));
    }

    /**
     * Update the persisted state that is passed to all events
     *
     * Calling
     * ```
     * tracker.update({ actor: 'person@example.org' });
     * tracker.trackPageView();
     * tracker.trackPageView();
     * ```
     *
     * is equivalent of doing
     *
     * ```
     * tracker.trackPageView({ actor: 'person@example.org' });
     * tracker.trackPageView({ actor: 'person@example.org' });
     * ```
     *
     * @param {Object} builder data passed to event functions
     *
     * @param {boolean} mergeBuilder the given data will be merged deeply with the
     * existing state. False will result in the previous state being overwritten
     *
     */
  }, {
    key: "update",
    value: function update(builder) {
      var mergeBuilder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      function conflictResolver(objValue, srcValue) {
        if (objValue instanceof Promise || srcValue instanceof Promise) {
          return Promise.all([objValue, srcValue]).then(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
              obj = _ref2[0],
              src = _ref2[1];
            return mergeWith({}, obj, src, conflictResolver);
          });
        }
        return undefined;
      }
      if (mergeBuilder) {
        this.builders = mergeWith({}, this.builders, builder, conflictResolver);
      } else {
        this.builders = _objectSpread(_objectSpread({}, this.builders), builder);
      }
    }

    /**
     * Get the environment id from the current browser. A promise is returned
     * because a CIS call is done to generate a new environmentId if no cookie is
     * found.
     *
     * *Note*: This method will return a Promise that is always rejected on node
        environments.
     */
  }, {
    key: "getEnvironmentId",
    value: function getEnvironmentId() {
      return this.cisSync().then(function (_ref3) {
        var environmentId = _ref3.environmentId;
        return environmentId;
      });
    }

    /**
     * Returns the UUID currently y used as the page view (will be muted by
     * `newPageView` and `trackPageView`).
     */
  }, {
    key: "getPageViewId",
    value: function getPageViewId() {
      return this.state.pageViewId;
    }

    /**
     * Set a page view id. Will be attached to all events until a new
     * id is generated.
     */
  }, {
    key: "setPageViewId",
    value: function setPageViewId(id) {
      this.state.pageViewId = id;
    }

    /**
     * Generate a new page view id. Will be attached to all events until a new
     * id is generated.
     */
  }, {
    key: "newPageView",
    value: function newPageView() {
      this.state.pageViewId = v4();
    }

    /**
     * @private
     */
  }, {
    key: "_getCollectorPath",
    value: function _getCollectorPath(providerId) {
      var _this$state2 = this.state,
        collectorBaseUrl = _this$state2.collectorBaseUrl,
        collectorPath = _this$state2.collectorPath,
        environment = _this$state2.environment;
      if (environment === 'node') {
        return "".concat(collectorBaseUrl, "/").concat(collectorPath);
      }
      var _provider = providerId || this.state.providerId;
      if (isString(_provider) && _provider.indexOf('sdrn') === 0) {
        return "".concat(collectorBaseUrl, "/").concat(collectorPath, "/").concat(_provider);
      }
      return "".concat(collectorBaseUrl, "/").concat(collectorPath, "/").concat(providerSdrn(_provider));
    }
  }, {
    key: "_getDataFromGlobalVars",
    value: function _getDataFromGlobalVars() {
      var dataFromGlobals = {};
      if (typeof window === 'undefined') {
        return {};
      }
      this.state.globalVarNames.forEach(function (globalName) {
        if (window[globalName] && _typeof(window[globalName]) === 'object') {
          try {
            dataFromGlobals = _objectSpread(_objectSpread({}, dataFromGlobals), window[globalName]);
          } catch (error) {
            // Any issues parsing global variable, it is skipped.
          }
        }
      });
      return dataFromGlobals;
    }

    /**
     * Send all events that are in the internal event queue.
     *
     * The returned Promise will resolve with 'true' when all events have been
     * successfully transmited. These events will have been removed from the event
     * queue. If the promise rejects it means that the event queue could not be
     * sent. Events that are unsuccessfully sent will remain in the event queue.
     *
     * @private
     *
     */
  }, {
    key: "_sendImmediately",
    value: function _sendImmediately() {
      var _this4 = this;
      if (this.queue.getQueuedEvents().length === 0) {
        return Promise.resolve(true);
      }
      return this.cisSync().then(function () {
        var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          doTracking = _ref4.doTracking;
        if (!doTracking) {
          return Promise.resolve(true);
        }
        var url = _this4._getCollectorPath(_this4.state.providerId);
        var sendHandler = function sendHandler(data) {
          return send(url, data, _this4.state);
        };
        return _this4.queue.sendEvents(sendHandler, _this4.state.eventBatchSize);
      });
    }
  }, {
    key: "_push",
    value: function _push(event) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.queue.queueEvent(event, options);
    }

    /**
     * Send the current event queue to the back end event receiver. This event is
     * debounced, see {SDKConfigInput} to override the default timing.
     *
     * This method is called by `track()` so it is not necessary to call after
     * adding events to the queue.
     */
  }, {
    key: "send",
    value: function send() {
      var _this5 = this;
      if (!this.debouncedSend) {
        this.debouncedSend = debounce(function () {
          _this5._sendImmediately()["catch"](function () {
            return {};
          });
        }, this.state.eventDebounce);
      }
      this.debouncedSend();
    }

    /**
     * A convenience method that does first updates the current pageViewId in the
     * tracker state and then sends a `tracker-event` with `@type: View` and the
     * merged result of the given data and the data saved in the tracker.
     *
     * Equivalent to
     *
     * ```
     * tracker.newPageView();
     * tracker.track('trackerEvent', { type: 'View', ...data });
     * ```
     *
     */
  }, {
    key: "trackPageView",
    value: function trackPageView(data, options) {
      this.newPageView();
      return this.track('trackerEvent', _objectSpread({
        type: 'View'
      }, data), options);
    }
  }]);
}();
export { Tracker as default };